import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const translations = {
    success: "Success",
    fail: "Fail",
};

export function addLabels(series) {
    return series.map((item) => ({
        ...item,
        label: translations[item.dataKey],
        valueFormatter: (v) => (v ? v : "-"),
    }));
}

export function createTableData(id, datetime, input, output, expected, status) {
    return { id, datetime, input, output, expected, status };
}

export function createPaginationData(page, pageSize, rows, totalPages) {
    return { page, pageSize, rows, totalPages };
}

export const fetchChartData = async () => {
    const response = await axios.get(`${API_BASE_URL}/dashboard/test-case-result-by-date`);
    return response.data;
};

export const fetchTableData = async (page) => {
    const uri = new URL(`${API_BASE_URL}/dashboard/test-case-result`);
    let p = page;
    if (!page) p = 1;
    uri.searchParams.append("page", p);
    uri.searchParams.append("page_size", 20);

    const response = await axios.get(uri.toString());
    return response.data;
};

export const fetchSummaryStatus = async () => {
    const response = await axios.get(`${API_BASE_URL}/dashboard/status`);
    return response.data;
};

export const fetchTestCaseStatus = async () => {
    const response = await axios.get(`${API_BASE_URL}/dashboard/test-case-result-overall`);
    return response.data;
};
